import api from './api';

const massSendService = {
  // 获取群发任务列表
  async getTaskList(params = {}) {
    try {
      // 支持更多查询参数
      const queryParams = {
        page: params.page || 0,
        size: params.size || 20,
        sortBy: params.sortBy || 'createdAt',
        sortDirection: params.sortDirection || 'desc',
        ...params  // 包括 status, taskType, createdBy, taskName, startDate, endDate 等
      };
      
      const response = await api.get('/v1/mass-send/tasks', { params: queryParams });
      return response.data;
    } catch (error) {
      console.error('获取群发任务列表失败:', error);
      throw error;
    }
  },

  // 根据ID获取群发任务详情
  async getTaskById(taskId) {
    try {
      const response = await api.get(`/v1/mass-send/tasks/${taskId}`);
      return response.data;
    } catch (error) {
      console.error('获取群发任务详情失败:', error);
      throw error;
    }
  },

  // 创建群发任务
  async createTask(taskData) {
    try {
      const response = await api.post('/v1/mass-send/tasks', taskData);
      return response.data;
    } catch (error) {
      console.error('创建群发任务失败:', error);
      throw error;
    }
  },

  // 更新群发任务
  async updateTask(taskId, taskData) {
    try {
      const response = await api.put(`/v1/mass-send/tasks/${taskId}`, taskData);
      return response.data;
    } catch (error) {
      console.error('更新群发任务失败:', error);
      throw error;
    }
  },

  // 删除群发任务
  async deleteTask(taskId) {
    try {
      await api.delete(`/v1/mass-send/tasks/${taskId}`);
    } catch (error) {
      console.error('删除群发任务失败:', error);
      throw error;
    }
  },

  // 执行群发任务
  async executeTask(taskId) {
    try {
      const response = await api.post(`/v1/mass-send/tasks/${taskId}/execute`);
      return response.data;
    } catch (error) {
      console.error('执行群发任务失败:', error);
      throw error;
    }
  },

  // 取消群发任务
  async cancelTask(taskId) {
    try {
      const response = await api.post(`/v1/mass-send/tasks/${taskId}/cancel`);
      return response.data;
    } catch (error) {
      console.error('取消群发任务失败:', error);
      throw error;
    }
  },

  // 添加任务成员
  async addTaskMembers(taskId, userIds) {
    try {
      const response = await api.post(`/v1/mass-send/tasks/${taskId}/members`, { userIds });
      return response.data;
    } catch (error) {
      console.error('添加任务成员失败:', error);
      throw error;
    }
  },

  // 移除任务成员
  async removeTaskMembers(taskId, userIds) {
    try {
      const response = await api.delete(`/v1/mass-send/tasks/${taskId}/members`, { data: { userIds } });
      return response.data;
    } catch (error) {
      console.error('移除任务成员失败:', error);
      throw error;
    }
  },

  // 更新任务目标
  async updateTaskTargets(taskId, targetConfig) {
    try {
      const response = await api.put(`/v1/mass-send/tasks/${taskId}/targets`, { targetConfig });
      return response.data;
    } catch (error) {
      console.error('更新任务目标失败:', error);
      throw error;
    }
  },

  // 获取任务统计
  async getTaskStats(params = {}) {
    try {
      const response = await api.get('/v1/mass-send/tasks/statistics', { params });
      return response.data;
    } catch (error) {
      console.error('获取任务统计失败:', error);
      throw error;
    }
  },

  // 验证任务配置
  async validateTaskConfig(taskData) {
    try {
      const response = await api.post('/v1/mass-send/tasks/validate', taskData);
      return response.data;
    } catch (error) {
      console.error('验证任务配置失败:', error);
      throw error;
    }
  }
};

export default massSendService; 